import {
  getMyAccountDetailsApi,
  putAccountNotificationSettingsApi,
  NotificationSettings,
  postCardNumberToResetPasswordSendSmsApi,
  ForgotChangePasswordVm,
  postNewPasswordDataToChangePasswordApi,
  UserDetailsVm
} from "@/services/accounts";
import { ApiCallParams } from "@/services/baseService";
import router from "@/router";
import routing from "@/constants/routes";
import actions from "./actions";

export default {
  actions: {
    async [actions.GET_MY_ACCOUNT_DETAILS](ctx?: any) {
      const accountDetailsMe:
        | UserDetailsVm
        | undefined = await getMyAccountDetailsApi();
      if (accountDetailsMe !== undefined) {
        ctx.commit("updateAccountDetailsMutation", accountDetailsMe);
      }
    },

    // async [actions.GET_MY_ACCOUNT_FULL_DASHBOARD_DETAILS](ctx?: any) {
    //   const accountDetailsMeDashboard:
    //     | UserDashboardVm
    //     | undefined = await getMyAccountFullDashboardDetailsApi();
    //   if (accountDetailsMeDashboard !== undefined) {
    //     ctx.commit("updateAccountFullDashboardDetailsMutation", accountDetailsMeDashboard);
    //   }
    //   ctx.commit("updateIsDashboardTransactionsGridLoadingMutation", false);
    // },

    async [actions.UPDATE_NOTIFICATION_SETTINGS](
      ctx?: any,
      params?: ApiCallParams<NotificationSettings>
    ) {
      if (params !== undefined) {
        await putAccountNotificationSettingsApi(params);
      }
    },

    async [actions.POST_CARD_NUMBER_TO_RESET_PASSWORD_SEND_SMS](
      ctx?: any,
      params?: ApiCallParams<number>
    ) {
      if (params !== undefined) {
        const result = await postCardNumberToResetPasswordSendSmsApi(params);

        if (result) {
          ctx.commit("updateUserPhone", result.phone);
          router.push({ path: routing.SETNEWPASS });
        }
        ctx.commit(
          "updateIsPostCardNumberToSendResetPasswordSmsCodeButtonLoadingMutation",
          false
        );
      }
    },

    async [actions.POST_NEW_PASSWORD_DATA_TO_CHANGE_PASSWORD](
      ctx?: any,
      params?: ApiCallParams<ForgotChangePasswordVm>
    ) {
      if (params !== undefined) {
        const result = await postNewPasswordDataToChangePasswordApi(params);

        if (result) {
          router.push({ path: routing.LOGIN });
        }

        ctx.commit("updateIsSetNewPasswordButtonLoadingMutation", false);
      }
    }
  },

  mutations: {
    updateAccountDetailsMutation(
      state?: any,
      fullAccountDetails?: UserDetailsVm
    ) {
      state.fullAccountDetails = fullAccountDetails;
    },

    updateAccountSettingsNotificationEmailsMutation(
      state?: any,
      emails?: boolean
    ) {
      state.fullAccountDetails.user.notificationSettings.emails = emails;
    },

    updateAccountSettingsNotificationPhoneMutation(
      state?: any,
      phone?: boolean
    ) {
      state.fullAccountDetails.user.notificationSettings.phone = phone;
    },

    updateAccountSettingsNotificationSmsMutation(state?: any, sms?: boolean) {
      state.fullAccountDetails.user.notificationSettings.sms = sms;
    },

    updateAccountSettingsNotificationLetterMutation(
      state?: any,
      letter?: boolean
    ) {
      state.fullAccountDetails.user.notificationSettings.letter = letter;
    },
    updateUserPhone(state?: any, phone?: string) {
      state.phone = phone;
    }
  },

  state: {
    fullAccountDetails: {} as UserDetailsVm,
    phone: ""
  },
  getters: {
    useAccountGetter(state?: any) {
      return state.account;
    }
  }
};
